<div [ngClass]="{'recent-tab__height-restrictor': !recentTabListModel.tabs[selectedTab].listModel?.items.length || recentTabListModel.tabs[selectedTab].hasError}"
        *ngIf="recentTabListModel.tabs?.length && !forceHideMru" #recentTab>
    <div class="visually-hidden" aria-live="polite">{{ screenReaderText }}</div>
    <ohp-tab-list [model]="recentTabListModel"
                    [defaultView] = "defaultView"
                    [columnsEnabled]="true"
                    [tileViewEnabled]="tileViewEnabled"
                    [listState]="initialListState"
                    (tabClicked)="onTabClicked($event)"
                    [defaultStateNoMinHeight]="true"
                    [customButtonEnabled]="uploadEnabled && headless"
                    [showFilter]="recentTabListModel?.tabs[selectedTab]?.loaded && filterEnabled"
                    [filterInput]="onFilter"
                    [isVisualRefresh]="isVisualRefresh"
                    [pillTabs]="fluentRefresh">
        <div ohpTabListButton>
            <ng-container *ngIf="uploadEnabled && headless"
                ohpLazyView ngModulePath="upload-button#UploadButtonModule"
                [inputs]="{
                    showAsLink: true,
                    fileType: fileType,
                    numDocuments: recentTabListModel?.tabs[selectedTab]?.listModel?.items?.length || 0
                }">
            </ng-container>
        </div>
        <div *ohpTabListItem="let item = item; let index = index; let itemView = itemView; let listId = listId; let focusOnLoad = focusOnLoad;">
            <ohp-mru-item *ngIf="!focusFirstItem" [item]="item" [index]="index" [view]="itemView" [listId]="listId" [showSharing]="showSharing" [showActivity]="showActivity" [showAnalytics]="showAnalytics" [focusOnLoad]="!focusOnFilter && focusOnLoad" [mruAppType]="fileType" (deleteItem)="onDeleteItem($event)" (changePinState)="onChangePinState($event)"></ohp-mru-item>
            <ohp-mru-item *ngIf="focusFirstItem" [item]="item" [index]="index" [view]="itemView" [listId]="listId" [showSharing]="showSharing" [showActivity]="showActivity" [showAnalytics]="showAnalytics" [focusOnLoad]="!focusOnFilter && index === 0" [mruAppType]="fileType" (deleteItem)="onDeleteItem($event)" (changePinState)="onChangePinState($event)"></ohp-mru-item>
        </div>
    </ohp-tab-list>
    <!-- This section of buttons was duplicated from above to test user engagement of adding content when
            the buttons are placed in a more noticeable location. TODO: If this will be expanded to other tabs,
            add it as a custom option in the tab model. -->
    <div *ngIf="emptyRecentNewButtonEnabled && !newMruEmptyStateEnabled && (createButtonEnabled || uploadEnabled)"
            class="buttons-container buttons-container--empty">
        <ng-container *ngIf="uploadEnabled"
            ohpLazyView ngModulePath="upload-button#UploadButtonModule"
            [inputs]="{
                buttonOrigin: emptyViewName,
                fileType: fileType,
                numDocuments: numLoggableItems
            }">
        </ng-container>
        <ng-container *ngIf="createButtonEnabled"
                        ohpLazyView
                        ngModulePath="create-menu#CreateMenuModule"
                        [inputs]="{
                            buttonOrigin: emptyViewName,
                            numDocuments: numLoggableItems,
                            withAnimation: false,
                            showDropdown: false
                        }">
        </ng-container>
    </div>
</div>
